import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className, y = 28, ...props }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.15 }) {
  return (
    <h1 className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="flex h-12 items-center overflow-hidden border-b border-lined bg-white" data-testid="home-marquee-ticker">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-editorial text-sm uppercase leading-[1.6] tracking-[0.28em] text-teal/80">
              {item}
            </span>
            <svg viewBox="0 0 12 12" className="h-2.5 w-2.5 shrink-0 text-aqua" fill="currentColor" aria-hidden="true">
              <circle cx="6" cy="6" r="6" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}

export function Overline({ children, dark = false }) {
  return (
    <p
      className={`font-mono text-xs font-semibold uppercase tracking-[0.22em] ${
        dark ? "text-aqua" : "text-teal"
      }`}
    >
      {children}
    </p>
  );
}
